module.exports = __webpack_public_path__ + "img/@logo_visang@3x.560be8cd.png";